import i18n from 'modules/core/lib/i18n'

import { TYPES } from 'modules/goals/store/models/GoalConfig'

export default function goalConfigsGoalType(list: string[]): string[] {
  const values = {
    [TYPES.numeric]: i18n.t(
      'custom_reports.especial_filters.goals_goal_configs_goal_type.options.numeric'
    ),
    [TYPES.none]: i18n.t(
      'custom_reports.especial_filters.goals_goal_configs_goal_type.options.empty'
    ),
  }

  return list.map((value) => values[value]).filter((value): value is string => value !== undefined)
}
